import styles from './AutoForm.module.scss';

interface TpTagInputFieldProps {
  id: string;
  onChange: (tags: string[]) => void;
}

export function TagInputField({ id, onChange }: TpTagInputFieldProps) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    // Check on Enter (13) or Tab (9) keyboard hit
    if (e.keyCode === 13 || e.keyCode === 9) {
      e.preventDefault();
      const inputElement = e.target as HTMLInputElement;
      const tagValue = inputElement.value.trim();
      if (tagValue !== '') {
        const tagElement = document.createElement('span');
        tagElement.innerHTML = tagValue;
        tagElement.className = styles.tag;
        tagElement.addEventListener('click', function () {
          tagElement.remove();
        });
        const container = document.createElement('div');
        container.className = styles.tagContainer;
        container.appendChild(tagElement);
        const parentElement = inputElement.parentNode;
        if (parentElement) {
          parentElement.insertBefore(container, inputElement);
        }
        inputElement.value = '';
      }
    }
  };

  return (
    <div className={styles.tagInputContainer}>
      <input
        type="text"
        id={id}
        onKeyDown={handleKeyDown}
        onChange={(ev) => {
          const values = document.getElementsByClassName(styles.tag);
          const tags = Array.from(values) ? Array.from(values).map((value) => value.textContent!) : [];
          onChange(tags);
        }}
      />
    </div>
  );
}
